import {gsap} from "gsap";

$(document).ready(function () {

    const category = getCategoryFromURL();
    if (category) {
        $(`.category-item[data-term="${category}"]`).addClass('active');
    } else {
        $('.works-filter__check-all').addClass('active');
    }
    doAjaxQuery(false);
});

function getCategoryFromURL() {
    return getParameterByName('category');
}

// AJAX
$('.category-item-not-all').on("click", function () {
    const $this = $(this);
    const currentTerm = $this.data("term");
    const isActive = $this.hasClass('active');

    if (!isActive) {
        // Remove "active" class from all category items and "All" button
        $('.category-item.active').removeClass('active');
        $('.works-filter__check-all.active').removeClass('active');

        $this.addClass("active");
        setSearchQueryBlog('category', currentTerm);
        doAjaxQuery(true);
    } else {
        $this.removeClass("active");
        setSearchQueryBlog('category', '');
        doAjaxQuery(true);
    }
});

$('.works-filter__check-all').on("click", function () {
    const $this = $(this);
    const currentSlug = $this.data("term");

    if (currentSlug === 'all') {
        // Remove "active" class from all category items
        $('.category-item.active').removeClass('active');

        $this.addClass('active');
        setSearchQueryBlog('category', ''); // Remove category from URL
        doAjaxQuery(true);
    }
});

// Additional logic to remove "active" class from "All works" button when other category items are clicked
$('.works-filter__wrap-titles .works-filter__accordion').on("click", function () {
    $('.works-filter__check-all.active').removeClass('active');
});

// URL
function setSearchQueryBlog(key, value) {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, value);
    let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
    history.pushState(null, 2, newRelativePathQuery);
}

// animation
function animateNewPosts($posts) {
    $posts.addClass("fade-in");
    setTimeout(() => {
        $posts.each(function (index) {
            setTimeout(() => {
                $(this).addClass("visible");
            }, index * 100);
        });
    }, 100);
}

function animateButton() {
    //elastic button animation
    $('.button-elastic-animation').on('mouseenter', function() {

        gsap.to(this, {
            //width: '+=10px',
            duration: 0.4,
            transformOrigin: 'left center'
        });

        // add animation keyframe jelly
        $(this).css('animation', 'jelly 0.5s');

        // stop after finish
        setTimeout(() => {
            $(this).css('animation', 'none');
        }, 500);
    });

    $('.button-elastic-animation').on('mouseleave', function() {

        gsap.to(this, {
            //width: 'auto',
            duration: 0.4,
            transformOrigin: 'left center'
        });

        $(this).css('animation', 'jelly 0.5s');

        setTimeout(() => {
            $(this).css('animation', 'none');
        }, 500);
    });
}

animateButton();

function doAjaxQuery(isCatQuery = false) {
    const categories = getParameterByName('category');
    const data = {
        'action': 'get_sort_for_works',
        'category': categories
    };

    loaderControl('add');

    $.ajax({
        url: MyAjax.ajaxurl,
        data: data, 
        type: 'POST', 
        success: function (data) {
            loaderControl('remove');

            if (data) {
                this_page = 1;
                const $wrapper = $(".works-content__wrapper");
                $wrapper.html(data);
                animateButton();
                // add animation
                if (isCatQuery) {
                    animateNewPosts($wrapper.find(".item"));
                }

                const maxPages = $("._blog-data").attr('data-max-pages');
                if (this_page >= maxPages) {
                    $('.btn-loadmore').addClass('hidden');
                } else {
                    $('.btn-loadmore').removeClass('hidden');
                }
            } else {
                $(".works-content__wrapper").empty();
                $('.btn-loadmore').addClass('hidden');
            }

            //for adding visible class to ajax elememts
            $(document).trigger('ajaxInitialLoad');
        },
        error: function (xhr, status, error) {
            console.error("Ajax Error:", status, error);
            loaderControl('remove');
            $(".works-content__wrapper").empty();
            $('.btn-loadmore').addClass('hidden');
        }
    });
}

// URL
function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function loaderControl(action) {
    const wrapper = $('.works-filter');
    if (action == 'add') {
        wrapper.addClass('loading');
    } else if (action == 'remove') {
        wrapper.removeClass('loading');
    }
}

// "Load More"
let isLoading = false;

$('.btn-loadmore').on('click', function () {
    if (isLoading) {
        return; // Prevent multiple clicks while loading
    }

    let _this = $(this);
    let _data = $('._blog-data');

    let data = {
        'action': 'loadmore',
        'query': _data.attr('data-param-posts'),
        'page': this_page,
    }

    isLoading = true;
    $.ajax({
        url: MyAjax.ajaxurl,
        data: data,
        type: 'POST', 
        success: function (data) {
            if (data) {
                $('.works-content__clear').remove()
                let $newPosts = $(data).filter(".item");

                // add new wlwmwnts to container
                let $wrapper = $('.works-content__wrapper');
                $wrapper.append($newPosts);

                 // add animation
                animateNewPosts($newPosts);

                this_page++;
                if (this_page == _this.attr('data-max-pages')) {
                    _this.addClass('hidden');
                }
            } else {
                _this.addClass('hidden');
            }

            const maxPages = $("._blog-data").attr('data-max-pages')
            if (maxPages == this_page) {
                _this.addClass('hidden');
            }

            //for adding visible class to ajax elements
            $(document).trigger('ajaxInitialLoad');

            isLoading = false; // Reset isLoading flag after AJAX request completes
        }
    });
});